import { render, staticRenderFns } from "./RelationList.vue?vue&type=template&id=4a1fa21a&scoped=true"
import script from "./RelationList.vue?vue&type=script&lang=ts"
export * from "./RelationList.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=4a1fa21a&prod&lang=scss&scoped=true&external"
import style1 from "./RelationList.vue?vue&type=style&index=1&id=4a1fa21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1fa21a",
  null
  
)

export default component.exports